import { SelectFilter } from '@gbs-monorepo-packages/common';

import { useCompanies } from '../../hooks/useCompanies';

export interface ISelectCompaniesProps {
  onValueChange?: (value: string) => void;
}

export const SelectCompanies = ({
  onValueChange,
}: ISelectCompaniesProps): JSX.Element => {
  const { companies, selectedCompany } = useCompanies();

  return (
    <SelectFilter
      attribute="name"
      data={companies}
      dataCy="select-companies"
      notFoundMessage="Client not found"
      onValueChange={onValueChange}
      placeholder="Select a client"
      selectedData={selectedCompany}
    />
  );
};
